import { getObjectTypeIconComponent } from 'customer-data-objects-ui-components/objects/getObjectTypeIconComponent';
import { useCardContextValue } from '../state/CardContext';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { CustomObjectIcon } from 'foundations-assets/icons/components/CustomObjectIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const smallProps = {
  size: '100',
  padding: '100'
};
const mediumProps = {
  borderWidth: '200',
  size: '300',
  padding: '100'
};
const largeProps = {
  size: '800',
  padding: '300',
  borderWidth: '300'
};
const AvatarIcon = ({
  size = 'medium'
}) => {
  const {
    objectTypeId
  } = useCardContextValue();
  const IconComponent = getObjectTypeIconComponent(objectTypeId, {
    DefaultIconComponent: CustomObjectIcon
  });
  let sizeProps = mediumProps;
  switch (size) {
    case 'large':
      sizeProps = largeProps;
      break;
    case 'small':
      sizeProps = smallProps;
      break;
    default:
      break;
  }
  return /*#__PURE__*/_jsx(IconCircle, Object.assign({
    icon: IconComponent,
    "data-test-id": "highlight-avatar-icon",
    backgroundColor: "fill-accent-neutral-subtle-alt",
    borderColor: "fill-accent-neutral-subtle-alt"
  }, sizeProps));
};
export default AvatarIcon;